export default "__VITE_ASSET__BfYAtp_O__"